// CacheKey 670da27a71298e2c6c32e84b516ab787
//
// DO NOT MODIFY: This file was automatically generated by JsFromTranslations.
export default {
  id: {
    date: {
      abbr_month_names: [
        null,
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "Mei",
        "Jun",
        "Jul",
        "Agu",
        "Sep",
        "Okt",
        "Nov",
        "Des"
      ],
      month_names: [
        null,
        "Januari",
        "Februari",
        "Maret",
        "April",
        "Mei",
        "Juni",
        "Juli",
        "Agustus",
        "September",
        "Oktober",
        "November",
        "Desember"
      ],
      order: [
        "day",
        "month",
        "year"
      ],
      day_names: [
        "Minggu",
        "Senin",
        "Selasa",
        "Rabu",
        "Kamis",
        "Jumat",
        "Sabtu"
      ],
      formats: {
        default: "%d/%m/%Y",
        long: "%d %B %Y",
        short: "%d %b"
      }
    },
    time: {
      am: "AM",
      pm: "PM"
    },
    time_zones: {
      est: "Waktu Timur",
      edt: "Waktu Timur",
      cst: "Waktu Tengah",
      cdt: "Waktu Tengah",
      mst: "Waktu Pegunungan",
      mdt: "Waktu Pegunungan",
      pst: "Waktu Pasifik",
      pdt: "Waktu Pasifik",
      hst: "Waktu Hawaii-Aleutian",
      hdt: "Waktu Hawaii-Aleutian",
      akst: "Waktu Alaska",
      akdt: "Waktu Alaska"
    }
  }
}

